// tslint:disable: cyclomatic-complexity
import Styled, { css } from 'styled-components';

import { cssDeclaration } from '../../../Utils';
import { IFocusControl, IInputError } from '../../common';
import { sharedLabelStyles, sharedRadioInputStyles } from '../common';

export const RadioCardLabel = Styled.label`
  ${sharedLabelStyles};
  position: absolute;
  top: 0;
  left: 0;

  ${({ theme: { themeTwo}}) => {
    const { form: { radio: { card }}} = themeTwo;

    return css`
      /* border-radius */ ${cssDeclaration(themeTwo, 'border-radius', card.round)};
      /* border */ ${cssDeclaration(themeTwo, 'border', card.border)};
      /* box-shadow */ ${cssDeclaration(themeTwo, 'box-shadow', card.shadow)};
    `;
  }}
`;

export const RadioCardContentContainer = Styled.div`
  width: 100%;

  ${({ theme: { themeTwo }}) => {
    const { form: { radio: { card }}} = themeTwo;

    return css`
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', card.backgroundColor)};
      /* border-radius */ ${cssDeclaration(themeTwo, 'border-radius', card.round)};
    `;
  }}
`;

export const RadioCardInput = Styled.input<IInputError & IFocusControl>`
  ${sharedRadioInputStyles};

  // tslint:disable:max-line-length
  ${({ theme: { themeTwo }, clickFocus, error: hasError }) => {
    const { form: { radio: { card }}} = themeTwo;
    const {
      state: {
        checked,
        disabled,
        focus,
        hover,
        error
      },
    } = card;

    return css`
      ${disabled && css`
        &:disabled + ${RadioCardLabel} {
          cursor: not-allowed;
          /* border */ ${disabled.border && cssDeclaration(themeTwo, 'border', disabled.border)};
          /* box-shadow */ ${disabled.shadow && cssDeclaration(themeTwo, 'box-shadow', disabled.shadow)};
        }

        &:disabled:hover + ${RadioCardLabel} {
          cursor: not-allowed;
          /* border */ ${disabled.border && cssDeclaration(themeTwo, 'border', disabled.border)};
        }
      `}

      &:checked + ${RadioCardLabel} {
        /* border */ ${checked.border && cssDeclaration(themeTwo, 'border', checked.border)};
        /* box-shadow */ ${checked.shadow && cssDeclaration(themeTwo, 'box-shadow', checked.shadow)};

        &:hover {
          cursor: pointer;
          /* border */ ${checked.border && cssDeclaration(themeTwo, 'border', checked.border)};
        }
      }

      ${!clickFocus && css`
        &:focus + ${RadioCardLabel} {
          /* border */ ${focus.border && cssDeclaration(themeTwo, 'border', focus.border)};
          /* box-shadow */ ${focus.shadow && cssDeclaration(themeTwo, 'box-shadow', focus.shadow)};
          /* outline */ ${focus.outline && cssDeclaration(themeTwo, 'outline', focus.outline)};
        }

        &:focus:checked + ${RadioCardLabel} {
          /* border */ ${checked.border && cssDeclaration(themeTwo, 'border', checked.border)};
        }
      `}

      &:hover + ${RadioCardLabel} {
        /* border */ ${hover.border && cssDeclaration(themeTwo, 'border', hover.border)};
        /* box-shadow */ ${hover.shadow && cssDeclaration(themeTwo, 'box-shadow', hover.shadow)};
      }

      &:checked ~ ${RadioCardContentContainer} {
        /* background-color */ ${checked.backgroundColor && cssDeclaration(themeTwo, 'background-color', checked.backgroundColor)};
      }

      &:hover ~ ${RadioCardContentContainer} {
        /* background-color */ ${hover.backgroundColor && cssDeclaration(themeTwo, 'background-color', hover.backgroundColor)};
      }

      &:disabled ~ ${RadioCardContentContainer} {
        /* background-color */
        ${disabled && disabled.backgroundColor &&
          cssDeclaration(themeTwo, 'background-color', disabled.backgroundColor)
        };
      }

      ${hasError && css`
        & + ${RadioCardLabel} {
          /* border */ ${error.border && cssDeclaration(themeTwo, 'border', error.border)};
          /* box-shadow */ ${error.shadow && cssDeclaration(themeTwo, 'box-shadow', error.shadow)};
          /* background-color */ ${error.backgroundColor && cssDeclaration(themeTwo, 'background-color', error.backgroundColor)};
        }
      `}
    `;
  }}
`;
